import { Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { useTitle } from '../../hooks/useTitle'


export default function DiagnosticsScreen() {
  const { t } = useTranslation()

  // Document title
  useTitle(t('pages.diagnostics'))

  return (
    <main>

      <Card>
        <CardHeader>
          <Heading size="md">{t('pages.diagnostics')}</Heading>
        </CardHeader>
        <CardBody>
          <Text>{t('general.wip')}</Text>
        </CardBody>
      </Card>

    </main>
  )
}
